export default "__VITE_ASSET__C2DuT_a1__"